import React, { createContext, useContext, useState, ReactNode } from 'react';

interface StatusProviderProps {
    children: ReactNode;
}

const StatusContext = createContext(
    {} as {
        status: string;
        setStatus: React.Dispatch<React.SetStateAction<string>>;
    },
);

export const useStatusContext = () => useContext(StatusContext);

export const StatusProvider = ({ children }: StatusProviderProps) => {
    const [status, setStatus] = useState('');

    return (
        <StatusContext.Provider value={{ status, setStatus }}>{children}</StatusContext.Provider>
    );
};
